import { Button } from "@material-ui/core";
import { Formik } from "formik";
import React, { useContext, useState } from "react";
import styled from "styled-components";
import ActionFormMenu from "./ActionFormMenuV2";
import ActionsContextV2 from "../ActionsContextV2";
import ActionOneTimeDeviationDialogV2 from "../actionsFormV2/ActionOneTimeDeviationDialogV2";
import ActionCommentsDialogV2 from "../actionsFormV2/ActionCommentsDialogV2";
import ActionDeviationDialogV2 from "../actionsFormV2/ActionDeviationDialogV2";
import ActionProcedureManualButtonV2 from "./ActionProcedureManualButtonV2";
import ActionsFormGroupV2 from "./ActionsFormGroupV2";
import ActionsPendingCompletedTabsV2 from "./ActionsPendingCompletedTabsV2";
import ActionChangeComplianceConfirmDialogV2 from "./ActionChangeComplianceConfirmDialogV2";
import ActionFormSearchV2 from "./ActionFormSearchV2";
import ActionFormCategoryFilterV2 from "./ActionFormCategoryFilterV2";
import ActionFormComplianceFilterV2 from "./ActionFormComplianceFilterV2";
import ActionsExportProceduresV2 from "./ActionsExportProceduresV2";
import ConfirmationDialog from "../../common/ConfirmationDialog";

const ActionFormGroupConatainer = styled.div`
  padding-bottom: 10px;
  width: 100%;

  display: flex;
`;

const ActionFormConatainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  overflow-y: auto;

  @media (max-width: 925px) {
    justify-content: left;
  }
`;

const Container = styled.div`
  margin: 20px;
  background: #f2f2f2 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 4px #00000047;
  border-radius: 8px;
  opacity: 1;
`;

const SubContainer = styled.div`
  padding-left: 30px;
  padding-right: 20px;
  padding-top: 20px;
  padding-bottom: 30px;
`;

const Header = styled.div`
  // height:54px;
  height: 34px;
  display: flex;
  padding-right: 20px;
  padding-left: 60px;

  align-items: center;
  justify-content: space-between;
`;

const ExpandCollapseAllContainer = styled.div`
  padding-left: 20px;
`;
const EmptyBottomDiv = styled.div`
  height: 200px;
  width: 100%;
`;

const ProjectFunction = styled.div`
  margin: 20px;
`;

const ButtonsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 20px 40px;
  align-items: center;
  height: 80px;
  margin-right: 12px;
`;

const SearchContainer = styled.div`
  display: flex;
  align-items: center;
`;

const TitleText = styled.div`
  font-family: Roboto;
  font-size: 20px;
  font-weight: 500;
  display: flex;
  flex: 1 1;
`;
const TitleContainer = styled.div`
  // padding-top:10px;
  padding-bottom: 0px;
  height: 70px;
  display: flex;
  align-items: center;
  padding-left: 20px;
`;

const ActionsFormV2 = ({ initialValues }) => {
  const context = useContext(ActionsContextV2);
  const [setAllToComplyAsIsFlag, setSetAllToComplyAsIsFlag] = useState(false)
  const [IsEnableSetAllToYesMenu, setIsEnableSetAllToYesMenu] = useState(false)
  const [isShowConfirmBox, setIsShowConfirmBox] = useState(false)

  if (!context.actionsRedux.selectedProjectFunctionDetails) return null;

  const {
    functionName,
    pendingActions,
    currentStepIndex,
    masterWorkflowSteps,
  } = context.actionsRedux.selectedProjectFunctionDetails;
  const masterWorkflowStep = masterWorkflowSteps[currentStepIndex]
    ? masterWorkflowSteps[currentStepIndex]
    : {};
  const actionToSubmit = pendingActions.filter(
    (action) => action.masterWorkflowStepIndex === currentStepIndex
  );
  const canSubmitStep =
    masterWorkflowStep.isCurrentUser ||
    masterWorkflowStep.isProxy ||
    (typeof masterWorkflowStep.proxy !== "undefined" &&
      masterWorkflowStep.proxy.some((prox) => {
        return (
          prox.bun.toString().toLowerCase() ===
          context.aboutCurrentUser.bun.toString().toLowerCase() &&
          (prox.isCurrentUser || prox.isProxy)
        );
      }));
  const isAssigned =
    context.actionsRedux.selectedProject.selectedFunction.isAssigned;

  const handleSetAllToYesMenue = () => {
    setIsShowConfirmBox(true)
  }

  return (
    <>
      {context.oneTimeDeviationDialogOpen && (
        <ActionOneTimeDeviationDialogV2 context={context} />
      )}
      {context.deviationDialogOpen && (
        <ActionDeviationDialogV2 context={context} />
      )}
      {context.commentsDialogOpen && (
        <ActionCommentsDialogV2 context={context} />
      )}
      {context.changeComplianceDialogOpen && (
        <ActionChangeComplianceConfirmDialogV2 context={context} />
      )}
      {context.downloadProcedures && <ActionsExportProceduresV2 />}

      <Container>
        <TitleContainer>
          <ActionProcedureManualButtonV2
            readOnly={!isAssigned}
            {...context.actionsRedux.selectedProjectFunctionDetails}
          />
          <TitleText>{functionName}</TitleText>

          {context.pendingCompletedTab === 0 && isAssigned && (
            <ButtonsContainer>
              <Button
                disabled={!canSubmitStep}
                onClick={() => context.submitPendingActions(actionToSubmit)}
                variant="contained"
                color="primary"
              >
                {`Submit Step ${currentStepIndex + 1}`}
              </Button>
              <div />
              <ActionFormMenu isLevel1={currentStepIndex === 0} handleSetAllToYesMenue={handleSetAllToYesMenue} setAllToComplyAsIsFlag={setAllToComplyAsIsFlag} IsEnableSetAllToYesMenu={IsEnableSetAllToYesMenu}/>
            </ButtonsContainer>
          )}

          {context.pendingCompletedTab === 0 && !isAssigned && (
            <ButtonsContainer>
              <Button hidden={true}></Button>
              <div />
              <ActionFormMenu isLevel1={false} handleSetAllToYesMenue={handleSetAllToYesMenue} setAllToComplyAsIsFlag={setAllToComplyAsIsFlag} IsEnableSetAllToYesMenu={IsEnableSetAllToYesMenu} />
            </ButtonsContainer>
          )}
        </TitleContainer>
        <Header>
          <ActionsPendingCompletedTabsV2 />

          <SearchContainer>
            <ActionFormComplianceFilterV2 />
            <ActionFormCategoryFilterV2 />
            <ActionFormSearchV2 />
          </SearchContainer>

          {/* {(context.pendingCompletedTab === 0 && isAssigned) &&

                      < ButtonsContainer>

                        <Button disabled={!canSubmitStep} onClick={()=>context.submitPendingActions(actionToSubmit) } variant="contained" color="primary">
                          {`Submit Step ${currentStepIndex + 1}`}
                        </Button>
                        <div/>
                        <ActionFormMenu isLevel1={currentStepIndex === 0} />
                      
                      </ButtonsContainer>
                    } */}
        </Header>
        <ActionFormConatainer ref={context.scrollRef}>
          <ActionFormGroupConatainer>
            <ActionsFormGroupV2 readOnly={!isAssigned} setAllToComplyAsIsFlag={setAllToComplyAsIsFlag} setSetAllToComplyAsIsFlag={setSetAllToComplyAsIsFlag} setIsEnableSetAllToYesMenu={setIsEnableSetAllToYesMenu} />
          </ActionFormGroupConatainer>
        </ActionFormConatainer>
      </Container>
      <ConfirmationDialog
        title="Are You sure?"
        subtitle={context.confirmGbuApproversSubtitle}
        body="You are about to 'Set All to Comply As-Is'. Are you sure you want to proceed?"
        open={isShowConfirmBox}
        onCancel={() => {
          setIsShowConfirmBox(false);
        }}
        onConfirm={() => {
          setIsEnableSetAllToYesMenu(0);
          setSetAllToComplyAsIsFlag(true);
          setIsShowConfirmBox(false);
          
        }}
      />

    </>
  );
};

export default ActionsFormV2;
